import React from 'react'
import './App.css'
import HCCLogo from './HCCS.png'

const App = () => (
  <div className="App bg-blue-900 text-white min-h-screen flex flex-col items-center p-6">
    <nav className="w-full max-w-7xl flex justify-between items-center py-4 px-6 bg-blue-800 bg-opacity-90 backdrop-blur-md rounded-b-2xl shadow-lg">
      <img src={HCCLogo} alt="Heroes Captains Clash" className="h-12" />
      <ul className="flex gap-8 text-lg">
        <li><a href="#format" className="hover:text-yellow-300">Format</a></li>
        <li><a href="#prizes" className="hover:text-yellow-300">Prizes</a></li>
        <li><a href="#streams" className="hover:text-yellow-300">Streams</a></li>
        <li><a href="#community" className="hover:text-yellow-300">Community</a></li>
      </ul>
    </nav>

    <header className="text-center mt-16 mb-12">
      <img src={HCCLogo} alt="Heroes Captains Clash" className="max-w-xs sm:max-w-md mb-8" />
      <p className="text-2xl font-semibold text-yellow-300">NA vs EU Showmatch</p>
      <p className="text-lg text-gray-300 mt-2">An epic tournament where the best players battle for glory!</p>
    </header>

    <section id="format" className="grid gap-8 w-full max-w-5xl">
      <div className="bg-gray-900 rounded-2xl shadow-xl p-8">
        <h2 className="text-3xl font-semibold text-yellow-300">Tournament Format</h2>
        <p className="mt-4 text-gray-400">Captains draft their teams, compete in a round-robin, and battle for the championship in a single-elimination bracket.</p>
      </div>
      <div id="prizes" className="bg-gray-900 rounded-2xl shadow-xl p-8">
        <h2 className="text-3xl font-semibold text-yellow-300">Prize Pool</h2>
        <p className="mt-4 text-gray-400">Cash prizes, exclusive merchandise, and eternal bragging rights.</p>
      </div>
      <div id="streams" className="bg-gray-900 rounded-2xl shadow-xl p-8">
        <h2 className="text-3xl font-semibold text-yellow-300">Live Streams</h2>
        <p className="mt-4 text-gray-400">Catch all the action live on Twitch and YouTube, with commentary from top analysts.</p>
      </div>
      <div id="community" className="bg-gray-900 rounded-2xl shadow-xl p-8">
        <h2 className="text-3xl font-semibold text-yellow-300">Join the Community</h2>
        <p className="mt-4 text-gray-400">Join our Discord server for updates, matchmaking, and epic banter.</p>
      </div>
    </section>
  </div>
)

export default App
